<!doctype html>
<html lang="en">
  <head>
    <meta charset="UTF-8" />
    <link rel="icon" type="image/svg+xml" href="/favicon.svg" />
    <meta name="viewport" content="width=device-width, initial-scale=1.0" />
    <meta
      name="description"
      content="@vibelibs/datagrid — the hand-crafted React datagrid for vibe coders. Real-time data, command palette, graph explorer, quality gates. One install, production-ready."
    />
    <meta name="keywords" content="react datagrid, react data table, real-time table, command palette table, graph explorer, typescript datagrid, vibe coding, developer tools" />

    <meta property="og:title" content="vibelibs/datagrid — The React Datagrid for Vibe Coders" />
    <meta
      property="og:description"
      content="Real-time updates. ⌘K command palette. Graph explorer. Quality gates. The only datagrid your React app will ever need."
    />
    <meta property="og:type" content="website" />
    <meta property="og:url" content="https://vibelibs.dev" />
    <meta name="twitter:card" content="summary_large_image" />
    <meta name="twitter:title" content="@vibelibs/datagrid — The React Datagrid for Vibe Coders" />
    <meta name="twitter:description" content="Real-time. Keyboard-first. Graph-aware. One install and your data UI is done." />

    <link rel="canonical" href="https://vibelibs.dev" />
    <title>vibelibs/datagrid — The React Datagrid for Vibe Coders</title>

    <script type="application/ld+json">
    {
      "@context": "https://schema.org",
      "@type": "SoftwareApplication",
      "name": "@vibelibs/datagrid",
      "alternateName": "vibelibs datagrid",
      "description": "Hand-crafted React datagrid component for vibe coding development. Includes real-time WebSocket data, command palette, graph explorer, quality gates, statistics charts, and split-view shell. TypeScript-first. Zero compromise.",
      "url": "https://vibelibs.dev",
      "applicationCategory": "DeveloperApplication",
      "operatingSystem": "Linux, macOS, Windows",
      "offers": [
        {
          "@type": "Offer",
          "name": "Indie License",
          "price": "79",
          "priceCurrency": "USD"
        },
        {
          "@type": "Offer",
          "name": "Team License",
          "price": "249",
          "priceCurrency": "USD"
        }
      ],
      "codeRepository": "https://github.com/vibelibs/datagrid",
      "keywords": "react datagrid, real-time table, command palette, graph explorer, typescript, vibe coding"
    }
    </script>
  </head>
  <body>
    <div id="root"></div>
    <script type="module" src="/src/main.tsx"></script>
  </body>
</html>
